import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueCookies from "vue3-cookies";
import { router } from "@/router/index.js";
import { i18n } from "@/locale/i18n";
import global from "@/plugin/global";
import store from "@/store/index.js";
import { $router, $axios } from "dot-framework";
import VueGtag from "vue-gtag";
import CKEditor from "@ckeditor/ckeditor5-vue";
import filter from "@/plugin/filter"
import mixins from "@/plugin/mixins"
import {clearSkippedFirmwareVersions} from "@/util/firmwareUpdatePreference"

/**
 * Bootstrap 설정
 */
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js"
import 'bootstrap-icons/font/bootstrap-icons.css';
/**
 * SweetAlert2 설정
 */
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// ---------------------------------
// app 선언
// ---------------------------------
const app = createApp(App);
app.use(i18n);                // 다국어 사용
app.use(store);               // vuex 사용
app.use(router);              // 라우터 사용
app.use(VueAxios, axios);     // axios 사용
app.use(VueCookies);          // 쿠키 사용
if (process.env.NODE_ENV === 'development') {
  window.clearDotPadFirmwareSkipCookies = (deviceModel) =>
      clearSkippedFirmwareVersions(app.config.globalProperties.$cookies, deviceModel);
}
app.use(VueSweetalert2);      // SweetAlert2 사용
app.use(CKEditor);            // CKEditor 사용

// 토스트 팝업창 템플릿
app.config.globalProperties.$showToast = function (title, message = '', type = 'success') {
    const iconClass = type === 'success' ? 'bi-check2' : type === 'error' ? 'bi-x' : 'bi-info';
    const iconColor = type === 'success' ? '#ea5414' : type === 'error' ? '#dc3545' : '#0d6efd';
    
    const srContextText = type === 'success' ? `${i18n.global.t('성공')}: ` : type === 'error' ? `${i18n.global.t('오류')}: ` : `${i18n.global.t('알림')}: `;

    this.$swal({
        toast: false, 
        backdrop: true, 
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        background: '#ffffff', 
        icon: 'none',
        html: `
          <div role="alert" aria-live="assertive" style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; width: 100%; min-height: 80px; padding: 10px 0;">
              
              <!-- [아이콘 + 제목] 묶음 -->
              <div style="display: flex; align-items: center; justify-content: center; gap: 12px; ${message ? 'margin-bottom: 8px;' : ''}">
                  <!-- 아이콘 -->
                  <div aria-hidden="true" style="background-color: ${iconColor}; border-radius: 50%; width: 28px; height: 28px; display: flex; justify-content: center; align-items: center; flex-shrink: 0;">
                      <i class="bi ${iconClass}" style="color: #fff; font-size: 18px;"></i>
                  </div>
                  
                  <div style="font-size: 20px; font-weight: 700; color: #111111; line-height: 1.2;">
                      ${title}
                  </div>
              </div>
              
              <!-- 스크린 리더용 숨김 텍스트 -->
              <span class="visually-hidden">${srContextText}</span>

              <!-- 상세 내용 (있을 때만 출력) -->
              ${message ? `
                  <div style="font-size: 18px; font-weight: 400; color: #555555; line-height: 1.4; width: 100%; margin-top: 4px;">
                      ${message}
                  </div>
              ` : ''}
              
          </div>
        `,
        customClass: {
            popup: 'modern-toast-popup'
        }
    });
};

if (process.env.VUE_APP_MODE === "real") {
  app.use(VueGtag, {    // Google Analytics 사용
    config: {
      id: "G-GKWZ7NS7BZ"
    }
  }, router);
}
app.config.devtools = true
app.config.globalProperties.$filter = filter
app.config.globalProperties.$mixins = mixins
app.mount("#app");

// ---------------------------------
// 라우트 이동처리 및 axios 인터셉터 처리
// ---------------------------------
$router.setBeforeEach(router);
$axios.interceptorsRequest();
$axios.interceptorsResponse();

// ---------------------------------
// 통합인증 및 메뉴/권한 설정
// ---------------------------------
global.setSession();
